<template>
  <section>
    <div class="h-100 row align-items-center no-gutters">
      <div class="container">
        <div class="col">
          <!-- Transações Selecionadas -->
          <div class="row">
            <div class="col">
              <div class="title">{{ $t("portfolio.title") }}</div>
            </div>
          </div>

          <!-- Grid Portfolio -->
          <div
            class="row text-center"
            style="margin-top: 49px; margin-bottom: 20px;"
          >
            <div class="col-sm-6 col-xl-4" v-for="item in $t('portfolio.products')" :key="item">
              <!-- Inicio -->
              <div class="card card-block d-flex">
                <div class="card-body justify-content-center card-content">
                  <div class="card-image">
                    <div
                      :style="{ backgroundImage: `url(${item.url})` }"
                      style="height: 180px; width: 100%; background-size: contain;"
                    >
                    </div>
                  </div>
                  <div class="row card-text">
                    <div class="col">
                    <h5> {{ item.title }} </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Portfolio",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section {
  background-color: #f9f9f9;
  padding: 160px 0px;
}

.title {
  font-family: Lora, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 42px;
  line-height: 60px;
  letter-spacing: -0.01em;
}

.content {
  font-family: " 'Open Sans', sans-serif;";
  font-style: normal;
  font-weight: normal;
  font-size: 31px;
  line-height: 50px;

  letter-spacing: -0.01em;

  width: 948px;
  margin-top: 55px;
}

.subtitle {
  font-family: Lora, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 41px;
  line-height: 52px;
  text-align: center;
  letter-spacing: -0.01em;
}

.card {
  height: 270px;
  border: 0px;

  background: #ffffff;

  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  overflow: hidden;
  -webkit-transition-property: transform;
  transition-property: transform;
  margin: 0 10px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
}

.card:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.card-text {
  padding: 20px;
  font-weight: 500;
  text-align: left;
}
.card-content {
  height: 100%;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height, or 22px */

  text-align: center;
  vertical-align: middle;
  letter-spacing: -0.01em;
}
.card-image {
  max-height: 180px;
  width: 100%;
}

.card-body {
  padding: 0;
}
.card-body .col {
  margin-bottom: 19px;
}

.mx-auto {
  padding: 10px;
}

@media (max-width: 575.98px) {
  section {
    padding: 80px 0px;
  }

  .title {
    font-size: 29px;
    line-height: 30px;
  }
}
</style>
